var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import Callbox from "./Callbox";
import HoverImage from "./FadingImage";
import HostName from "./HostName";
import OnlineStateIcon from "./OnlineStateIcon";
import WebpushButton from "./WebpushButton";
import Languages from "./Languages";
import { Link } from "react-router-dom";
import { getImages } from "../Helper/PreviewImageSelector";
function Host(_a) {
  var host = _a.host;
  var images = getImages(host);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "hostimage c-host-grid__card__image"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/profil/".concat(host.name, "/")
  }, /*#__PURE__*/React.createElement("span", {
    className: 'sr-only'
  }, "Zum profil von ", host.name), /*#__PURE__*/React.createElement(HoverImage, {
    imageUrls: images,
    senderName: host.name
  }), /*#__PURE__*/React.createElement(OnlineStateIcon, {
    state: host.status
  }), /*#__PURE__*/React.createElement(Languages, {
    host: host
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hostname c-host-grid__card__name"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/profil/".concat(host.name, "/")
  }, /*#__PURE__*/React.createElement(HostName, __assign({}, host)))), /*#__PURE__*/React.createElement("div", {
    className: "hostcall c-host-grid__card__call"
  }, /*#__PURE__*/React.createElement(Callbox, __assign({}, host))), /*#__PURE__*/React.createElement(WebpushButton, {
    host: host,
    position: 'host'
  }));
}
export default Host;